import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { AppShell } from '../components/layout/AppShell';
import { EstimateForm } from '../components/estimates/EstimateForm';
import { useCreateEstimate } from '../hooks/useEstimates';
import { markFormSaved } from '../hooks/useUnsavedChanges';
import { apiErrorMessage } from '../lib/api-error-message';
import { useToastHelpers } from '../components/ui';
import type { CreateEstimateInput } from '@armard/shared';

export const Route = createFileRoute('/estimates_/new')({
  validateSearch: z.object({ customerId: z.string().uuid().optional() }),
  component: NewEstimatePage,
});

function NewEstimatePage() {
  const navigate = useNavigate();
  const toast = useToastHelpers();
  const createEstimate = useCreateEstimate();
  const { customerId } = Route.useSearch();

  const save = async (
    values: CreateEstimateInput | import('@armard/shared').UpdateEstimateInput
  ) => {
    try {
      const estimate = await createEstimate.mutateAsync(values as CreateEstimateInput);
      markFormSaved();
      toast.success('Angebot erstellt');
      await navigate({ to: '/estimates/$id', params: { id: estimate.id } });
    } catch (error) {
      toast.error(apiErrorMessage(error, 'Fehler beim Erstellen des Angebots'));
    }
  };

  return (
    <ProtectedRoute>
      <AppShell>
        <EstimateForm
          initialCustomerId={customerId}
          title="Neues Angebot"
          submitLabel="Angebot erstellen"
          isSaving={createEstimate.isPending}
          onCancel={() => navigate({ to: '/estimates' })}
          onSave={save}
        />
      </AppShell>
    </ProtectedRoute>
  );
}
